__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "jeean-parkrisk";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@stararc/amap", "2.3.35", () => (Promise.all([__webpack_require__.e(1397), __webpack_require__.e(9788), __webpack_require__.e(6044), __webpack_require__.e(2770), __webpack_require__.e(8721), __webpack_require__.e(6367), __webpack_require__.e(2444)]).then(() => (() => (__webpack_require__(92329))))));
			register("@stararc/hooks", "2.3.17", () => (Promise.all([__webpack_require__.e(853), __webpack_require__.e(2081), __webpack_require__.e(8721), __webpack_require__.e(4467)]).then(() => (() => (__webpack_require__(22081))))));
			register("@stararc/ui", "2.4.3", () => (Promise.all([__webpack_require__.e(853), __webpack_require__.e(1397), __webpack_require__.e(3501), __webpack_require__.e(3361), __webpack_require__.e(9788), __webpack_require__.e(900), __webpack_require__.e(8721)]).then(() => (() => (__webpack_require__(21555))))));
			register("@stararc/utils", "2.3.21", () => (Promise.all([__webpack_require__.e(1397), __webpack_require__.e(3501), __webpack_require__.e(4963)]).then(() => (() => (__webpack_require__(84963))))));
			initExternal(64143);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};